/**
 * 工具类
 */
import CryptoJS from 'crypto-js'
//日期格式化
import moment from 'moment'

export default {
    //加密
    encrypt(word, keyStr) {
        keyStr = keyStr ? keyStr : 'wycs20190801'
        let key = CryptoJS.enc.Utf8.parse(keyStr)
        let srcs = CryptoJS.enc.Utf8.parse(word)
        let encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        return encodeURIComponent(encrypted).toString()
    },
    //解密
    decrypt(word, keyStr) {
        keyStr = keyStr ? keyStr : 'wycs20190801'
        let key = CryptoJS.enc.Utf8.parse(keyStr)
        let zword = decodeURIComponent(word)
        let decrypt = CryptoJS.AES.decrypt(zword, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        return CryptoJS.enc.Utf8.stringify(decrypt).toString()
    },
    //时间戳转日期格式
    dateFormat(data, keyStr) {
        return moment(new Date(data * 1000)).format(keyStr)
    },
    //时间戳转日期格式
    dateToFormat(data, keyStr) {
        return moment(new Date(data)).format(keyStr)
    },
    formatDateTime(time) {
        let date = new Date(time);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        var minute = date.getMinutes();
        var seconds = date.getSeconds()
        minute = minute < 10 ? ('0' + minute) : minute;
        seconds = seconds < 10 ? ('0' + seconds) : seconds;
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + seconds;
    },
    //已创建天数
    createdDays(data) {
        let now = new Date().getTime()
        let time = data * 1000
        let days = Math.ceil((now - time) / (24 * 60 * 60 * 1000))
        return days
    },
    //判断是否当天
    isSameDay(data) {
        let time = moment(new Date(data * 1000)).format('YYYY-MM-DD')
        let now = moment(new Date().getTime()).format('YYYY-MM-DD')
        return time == now
    },
    //截取地址参数值
    getParameter: function(url, key) {
        try {
            let regExp = new RegExp('^.*[?&]' + key + '=([^&=?]*)&?.*$', '')
            let parameter = url.replace(regExp, '$1')
            return parameter
        } catch (error) {
            return null
        }
    },
    //生成日期数字
    nowFormat: function() {
        let date = new Date()
        let year = date.getFullYear()
            /* 在日期格式中，月份是从0开始的，因此要加0
             * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
             * */
        let month =
            date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1
        let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
        let minutes =
            date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
        let seconds =
            date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            // 拼接
        return year + month + day + hours + minutes + seconds
    },
    //数字转大写
    snumToLnum: function(v) {
        var week = ''
        var weeks = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '百']
        if (v > 0) {
            if (v <= 10) {
                week = weeks[v]
            } else if (v > 10 && v < 100) {
                var num = v.toString().split("")
                week = num[0] > 1 ? weeks[num[0]] + weeks[10] : weeks[10]
                week = num[1] > 0 ? week + weeks[num[1]] : week
            } else if (v >= 100 && v < 1000) {
                var num = v.toString().split("")
                week = weeks[num[0]] + weeks[11]
                if (!(num[1] == 0 && num[2] == 0)) {
                    week = num[1] > 0 ? week + weeks[num[1]] + weeks[10] : week + weeks[0]
                    week = num[2] > 0 ? week + weeks[num[2]] : week
                }
            }
        }
        return week
    },
    //获取上传类型
    getUploadType: function(key) {
        let type = { id: '', name: '*' }
        switch (key) {
            case 'doc':
                type = { id: 'doc', name: 'application/msword' }
                break;
            case 'docx':
                type = { id: 'docx', name: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }
                break;
            case 'xls':
                type = { id: 'xls', name: 'application/vnd.ms-excel' }
                break;
            case 'xlsx':
                type = { id: 'xlsx', name: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
                break;
            case 'ppt':
                type = { id: 'ppt', name: 'application/vnd.ms-powerpoint' }
                break;
            case 'pptx':
                type = { id: 'pptx', name: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' }
                break;
            case 'pdf':
                type = { id: 'pdf', name: 'application/pdf' }
                break;
            case 'mp3':
                type = { id: 'mp3', name: 'audio/mpeg' }
                break;
            case 'mp4':
                type = { id: 'mp4', name: 'video/mp4' }
                break;
            case 'mov':
                type = { id: 'mov', name: 'video/mov' }
                break;
            case 'jpg':
                type = { id: 'jpg', name: 'image/jpg' }
                break;
            case 'png':
                type = { id: 'png', name: 'image/png' }
                break;
        }
        return type
    }
}


// WEBPACK FOOTER //
// ./src/api/utils.js